import { render, staticRenderFns } from "./ComplaintComponent.vue?vue&type=template&id=4cbeea3b&"
import script from "./ComplaintComponent.vue?vue&type=script&lang=js&"
export * from "./ComplaintComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports